import { combineReducers } from '@reduxjs/toolkit';
import { searchSlice } from './search/store/slice';
import { sendSlice } from './send/store/slice';

export const emailReducer = combineReducers({
  send: sendSlice.reducer,
  search: searchSlice.reducer,
});
